import { render } from "./HistoryColumn.vue?vue&type=template&id=a9b8b0b2&scoped=true"
import script from "./HistoryColumn.vue?vue&type=script&lang=js"
export * from "./HistoryColumn.vue?vue&type=script&lang=js"

import "./HistoryColumn.vue?vue&type=style&index=0&id=a9b8b0b2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a9b8b0b2"

export default script